import {
  defaultTypography,
  GSActionBar,
  GSEmptyList,
  GSInput,
  GSItemList,
} from "golfstatus_react_components";
import TournamentSponsorLineItem from "../components/tournament/tournament-sponsorships/tournament-sponsor-line-item";
import {
  faExternalLinkSquareAlt,
  faSearch,
  faTimesCircle,
} from "@fortawesome/free-solid-svg-icons";

export const editSponsorshipTierForm = (context, currentSponsorshipTier) => {
  if (context) {
    let isTechTier =
      currentSponsorshipTier?.sponsorshipTierType === "technology";

    let isDefaultTier =
      currentSponsorshipTier?.sponsorshipTierType === "default";

    let tierInfo = {
      type: "vertical xx-large-gap",
      fields: [
        {
          label: "Tier Name",
          failedValidation: context?.validationFailed,
          value: currentSponsorshipTier?.name ?? "",
          isEditable: true,
          required: true,
          onChange: (e) => context.updateData(e.target.value, "name"),
          placeholder: "Tier Name",
          customView: isDefaultTier ? true : false,
          hintText: isDefaultTier ? "The default sponsor tier can’t be renamed." : "",
        },
      ],
    };

    let form = [{ ...tierInfo }];

    let sponsorInfo = {
      type: "vertical xx-large-gap no-wrap",
      title: !isTechTier ? (
        <span style={{ ...defaultTypography.mediumBoldBody }}>Sponsors</span>
      ) : null,
      sectionActions: !isTechTier ? context?.getActions() : [],
      fields: [
        {
          value: (
            <GSItemList
              type="vertical small-gap grey-empty-list rounded-empty-list"
              items={context?.currentSponsorshipTierSponsors}
              emptyMessage={
                isTechTier
                  ? context?.getTechEmptyMessage?.()
                  : context?.getEmptyMessage?.()
              }
              listItem={(item) => (
                <TournamentSponsorLineItem
                  {...item}
                  tierView={true}
                  sponsorshipTier={currentSponsorshipTier}
                />
              )}
              loading={context.tierLoading?.length > 0}
              loadingMainText="Loading Sponsors..."
            />
          ),
        },
      ],
    };

    if (currentSponsorshipTier?.id) {
      form.push({ ...sponsorInfo });
    }

    return form;
  }
};

export const getTierPaidMessage = (header) => {
  return (
    <gs-form>
      <GSActionBar type="form-header" header={header} />
      <GSItemList
        items={[]}
        type="vertical"
        emptyMessage={
          <GSEmptyList
            title="Paid Feature"
            detail="The Technology Sponsorship must be purchased to unlock sponsorship tiers. Please contact your sales or client success representative with questions or to learn more."
            actions={[
              {
                title: "learn more",
                rightIcon: faExternalLinkSquareAlt,
                onClick: () => {
                  window.open(
                    "https://golfstatus.com/technology-sponsor",
                    "_blank"
                  );
                },
                type: "light-grey",
              },
            ]}
          />
        }
      />
    </gs-form>
  );
};

export const TIER_MANAGEMENT_LIST = "tier-management-list";

export const manageSponsorsForm = (context, currentSponsorshipTier) => {
  if (context) {
    let sponsorInfo = {
      title: "Assigned Sponsors",
      type: "vertical scrollable xx-large-gap no-wrap",
      fields: [
        {
          value: (
            <GSItemList
              listID={TIER_MANAGEMENT_LIST}
              type="vertical scrollable small-gap grey-empty-list rounded-empty-list"
              items={context?.currentSponsorshipTierSponsors}
              itemRemoved={context?.removeSponsorFromTier}
              itemMoved={context?.reorderSponsors}
              isSortable={true}
              enableStep={false}
              bottomScrollMargin={40}
              topScrollMargin={40}
              emptyMessage={context?.getEmptyMessage?.()}
              listItem={(item) => (
                <TournamentSponsorLineItem
                  {...item}
                  editTierView={true}
                  tierView={true}
                  removeSponsor={() => context?.removeSponsor(item)}
                  sponsorshipTier={currentSponsorshipTier}
                />
              )}
              loading={context.tierLoading?.length > 0}
              loadingMainText="Loading Sponsors..."
            />
          ),
        },
      ],
    };

    if (context?.availableSponsors.length > 0 || context?.search !== "") {
      sponsorInfo.fields.push(
        {
          label: "Available Sponsors",
          value: (
            <GSInput
              textValue={context?.search}
              onChange={(e) => {
                context?.setSearch(e.target.value);
              }}
              placeholder="Search Available Sponsors..."
              leftIcon={faSearch}
              rightIcon={faTimesCircle}
              rightIconClick={() => {
                context?.setSearch("");
              }}
            />
          ),
        },
        {
          value: (
            <GSItemList
              type="vertical small-gap grey-empty-list rounded-empty-list"
              items={context?.availableSponsors}
              emptyMessage={
                context?.search !== ""
                  ? context?.getEmptySearchMessage()
                  : context?.getEmptyListMessage()
              }
              listItem={(item) => (
                <TournamentSponsorLineItem
                  {...item}
                  tierView={true}
                  addToTierView={true}
                  addSponsorToTier={() => context?.addSponsorToTier(item)}
                  sponsorshipTier={context?.findTier(item)}
                />
              )}
              loading={context.tierLoading?.length > 0}
              loadingMainText="Loading Sponsors..."
            />
          ),
        }
      );
    }

    let form = [{ ...sponsorInfo }];

    if (context.tournamentSponsorsCount === 0) {
      let emptyForm = {
        type: "vertical xx-large-gap no-wrap",
        fields: [
          {
            value: (
              <GSItemList
                type="vertical small-gap selectable grey-empty-list rounded-empty-list"
                items={context?.availableSponsors}
                emptyMessage={
                  context?.search !== ""
                    ? context?.getEmptySearchMessage()
                    : context?.getEmptyListMessage()
                }
                listItem={(item) => (
                  <TournamentSponsorLineItem
                    {...item}
                    tierView={true}
                    addToTierView={true}
                    addSponsorToTier={() => context?.addSponsorToTier(item)}
                    sponsorshipTier={context?.findTier(item)}
                  />
                )}
                loading={context.tierLoading?.length > 0}
                loadingMainText="Loading Sponsors..."
              />
            ),
          },
        ],
      };
      return (form = [{ ...emptyForm }]);
    }

    return form;
  }
};
